import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "js-longCalculation",
  class: "premium-box premium-calculator-block__block-card block-card block-card--bg-light-grey"
}
const _hoisted_2 = { class: "block-card__content" }
const _hoisted_3 = { class: "table" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "table" }

import { usePremCalcStore } from "@premcalc/store/premCalcStore";
import LongCalculationValues from "./longCalculationValues.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'longCalculation',
  setup(__props) {

const store = usePremCalcStore();
const tableTranslations = store?.translations?.longTable;

const hasAmount = store?.longCalculation?.values.some((value) => {
  return value.category === "A" && value.valueAmount !== null
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, _toDisplayString(_unref(tableTranslations)?.debtorCategory), 1 /* TEXT */),
            _createElementVNode("th", null, _toDisplayString(_unref(tableTranslations)?.TypicalTransactions), 1 /* TEXT */),
            _createElementVNode("th", null, _toDisplayString(_unref(tableTranslations)?.premiumValuePct), 1 /* TEXT */),
            (_unref(hasAmount))
              ? (_openBlock(), _createElementBlock("th", _hoisted_4, _toDisplayString(_unref(tableTranslations)?.premiumValueAmount), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            (_unref(hasAmount))
              ? (_openBlock(), _createElementBlock("th", _hoisted_5, _toDisplayString(_unref(tableTranslations)?.premiumValueYearly), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store)?.longCalculation?.values, (values, key) => {
            return (_openBlock(), _createBlock(LongCalculationValues, {
              key: key,
              values: values,
              hasAmount: _unref(hasAmount)
            }, null, 8 /* PROPS */, ["values", "hasAmount"]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, _toDisplayString(_unref(tableTranslations)?.headingGuarType), 1 /* TEXT */),
            _createElementVNode("th", null, _toDisplayString(_unref(tableTranslations)?.headingGuarPct), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(tableTranslations)?.centralBank), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(_unref(store).longCalculation?.guaranteePctCentralBank), 1 /* TEXT */)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(tableTranslations)?.other), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(_unref(store).longCalculation?.guaranteePctOtherBuyers), 1 /* TEXT */)
          ])
        ])
      ])
    ])
  ]))
}
}

})